import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "infocliq-edc85.firebaseapp.com",
  projectId: "infocliq-edc85",
  storageBucket: "infocliq-edc85.appspot.com",
  messagingSenderId: "840622974978",
  appId: "1:840622974978:web:d621f97034b350c7de5f1b"
};

let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  console.error("Firebase initialization failed:", error);
  // Provide fallback or mock
}

export const storage = app ? getStorage(app) : null;
export const db = app ? getFirestore(app) : null;
export const auth = app ? getAuth(app) : null;